import * as Init from '../init.js';
import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'
import * as FOPTION from './foption.res.js'

function getMclassName(inData) {
    let mclassindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'mclassindex', 0), inData['workers'].length)
    return inData['workers'][mclassindex]
}
function changeFactorInfo(inData, redraw) {
    const mclassname = getMclassName(inData)
    console.log(inData);
    
    FOPTION.clearFactors()
    
    for (let index = 0; index < inData['factors'].datas.length; index++) {
        let infos = []
        infos.push(CLAPI.getData(inData['verify'], 'upvalid', index))
        infos.push(-1 * CLAPI.getData(inData['verify'], 'dnvalid', index))
        FOPTION.incrFactors(CLAPI.getData(inData['factors'], 'name', index), infos)
    }
    
    if (redraw) {
        const curChart = Init.getSysChart()
        const chart = curChart.getUserChart('factorCtrl', 'factorCtrl')
        chart.changeCtrls(FOPTION.CHART_OPTION_FACTORS.ctrls)
    }
}
function setFactorCtrl(curChart, chartName, inData, region) {
    const chart = curChart.getChart(chartName)

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            offset: { // 图形的偏移位置（不包括标题等），margin为整个图形区，offset仅仅是图形
                left: 1,
                top: 1,
                right: 0,
                bottom: 1,
            },
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 4, // Y方向留空
            }
        },
        config: FOPTION.CHART_OPTION_FACTORS,
        rectMain: curRect

    }
    FOPTION.setFactorsTitle('因子集(' + inData['factors'].datas.length + ')')
    
    const mclassname = getMclassName(inData)
    
    changeFactorInfo(inData, false)

    let factorindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'factorindex', 0), inData['factors'].datas.length)
    curCfg.config.selectIndex = factorindex

    const curchart = chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            if (result.selectIndex < 0) {
                return factorindex
            }
            else if (result.selectIndex !== factorindex ) {
                Init.setUserInfo(inData.modulename, mclassname + 'factorindex', result.selectIndex)
                factorindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'factorindex', 0), inData['factors'].datas.length)
                onLoadData(inData, false)
            }
        }
    })
}
function setMclassCtrl(curChart, chartName, inData, region) {
    const chart = curChart.getChart(chartName)

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 2, // Y方向留空
            }
        },
        config: FOPTION.CHART_OPTION_MCLASS,
        rectMain: curRect

    }
    let mclassindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'mclassindex', 0), inData['workers'].length)
    curCfg.config.selectIndex = mclassindex;
    
    const curchart = chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            if (result.selectIndex >= 0 && result.selectIndex !== mclassindex ) {
                Init.setUserInfo(inData.modulename, 'mclassindex', result.selectIndex)
                mclassindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'mclassindex', 0), inData['workers'].length)
                onClassLoad(inData)
            }
        }
    })
}
function setMinuteCtrl(curChart, chartName, inData, region) {
    const chart = curChart.getChart(chartName)

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 2, // Y方向留空
            }
        },
        config: FOPTION.CHART_OPTION_MINUTE,
        rectMain: curRect

    }
    const mclassname = getMclassName(inData)

    let minuteindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'minuteindex', 0), inData['minutes'].length)
    
    curCfg.config.selectIndex = minuteindex;
    
    const curchart = chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            // console.log(chartName, result)
            Init.setUserInfo(inData.modulename, mclassname + 'minuteindex', result.selectIndex)
            onLoadData(inData, true)
        }
    })
}

function setMainChart(curChart, chartName, inData, region) {
    
    const chart = curChart.getChart('mainChart')
    let curname = '跌'
    if (chartName === 'UpChart') {
        curname = '涨'
    }
    
    {
        const cvname = chartName + 'weight'
        const curRect = CLAPI.getChartRect(region, 1, 4, 0, 0)
        // 设置界面信息和绑定数据
        const curCfg = {
            layout: {
                offset: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5
                }
            },
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: curname + '权重:',
                    },
                    lines: FOPTION.LINES_OPTION_WEIGHT,
                },
                FOPTION.CHART_OPTION_HEAD),
            rectMain: curRect
        }
        // console.log(curCfg);
        // 其他为辅助数据 实际运算时
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
        })
        chart.bindData(curchart, cvname)
    }
    {
        const cvname = chartName + 'rate'
        const curRect = CLAPI.getChartRect(region, 1, 4, 0, 1)
        // 设置界面信息和绑定数据
        const curCfg = {
            layout: {
                offset: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5
                }
            },
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: curname + '幅度:',
                    },
                    lines: FOPTION.LINES_OPTION_RATE,
                },
                FOPTION.CHART_OPTION_HEAD),
            rectMain: curRect
        }
        // console.log(curCfg);
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
        })
        chart.bindData(curchart, cvname)
    }
    {
        const cvname = chartName + 'nums'
        const curRect = CLAPI.getChartRect(region, 1, 4, 0, 2)
        // 设置界面信息和绑定数据
        const curCfg = {
            layout: {
                offset: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5
                }
            },
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: curname + '数量:',
                    },
                    axisY: {
                        left: {
                            format: 'vol'
                        },
                        right: {
                            format: 'vol'
                        }
                    },
                    lines: FOPTION.LINES_OPTION_NUMS,
                },
                FOPTION.CHART_OPTION_HEAD),
            rectMain: curRect
        }
        // console.log(curCfg);
        // 其他为辅助数据 实际运算时
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
        })
        chart.bindData(curchart, cvname)
    }
    if (chartName === 'UpChart')
    {
        const cvname = chartName + 'area'
        const curRect = CLAPI.getChartRect(region, 1, 4, 0, 3)
        // 设置界面信息和绑定数据
        const curCfg = {
            layout: {
                offset: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5
                }
            },
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: '因子分类:',
                    },
                    lines: FOPTION.LINES_OPTION_AREA,
                },
                FOPTION.CHART_OPTION_HEAD),
            rectMain: curRect
        }
        // console.log(curCfg);
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
        })
        chart.bindData(curchart, cvname)
    }
    else {
        const cvname = chartName + 'sums'
        const curRect = CLAPI.getChartRect(region, 1, 4, 0, 3)
        // 设置界面信息和绑定数据
        const curCfg = {
            layout: {
                offset: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5
                }
            },
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: '样本分布:',
                    },
                    lines: FOPTION.LINES_OPTION_SUMS,
                },
                FOPTION.CHART_OPTION_HEAD),
            rectMain: curRect
        }
        // console.log(curCfg);
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
        })
        chart.bindData(curchart, cvname)
    }
}

function readyMainChart(curChart, inData) {
    const chart = curChart.getChart('mainChart')
    
    const mclassname = getMclassName(inData)
    const factorindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'factorindex', 0), inData['factors'].datas.length)
    const factorname = CLAPI.getData(inData['factors'], 'name', factorindex)
    
    {
        const chartName = 'UpChart'
        const curdatas = FOPTION.optionToData(chartName, factorname, inData['verify'], inData['assess'])
        const axisXinfo = DATAS.extractField(curdatas, 'index')
        chart.setAxisXinfo(axisXinfo)
    
        chart.setData(chartName + 'nums', curdatas)
        chart.setData(chartName + 'rate', curdatas)
        chart.setData(chartName + 'area', curdatas)
        chart.setData(chartName + 'sums', curdatas)
        chart.setData(chartName + 'weight', curdatas)
    }
    {
        const chartName = 'DnChart'
        const curdatas = FOPTION.optionToData(chartName, factorname, inData['verify'], inData['assess'])
        const axisXinfo = DATAS.extractField(curdatas, 'index')
        chart.setAxisXinfo(axisXinfo)
    
        chart.setData(chartName + 'nums', curdatas)
        chart.setData(chartName + 'rate', curdatas)
        chart.setData(chartName + 'area', curdatas)
        chart.setData(chartName + 'sums', curdatas)
        chart.setData(chartName + 'weight', curdatas)
    }

}

function drawFOption(inData, isFirst) {

    console.log('Draw ====> FOption Line')
    // console.log(JSON.stringify(inData));
    // console.log(inData);
    
    const curChart = Init.getSysChart()

    if (isFirst) {
        // 设置为单一窗口 并返回第一个窗口
        curChart.initChart(['mainChart', 'mclassCtrl', 'minuteCtrl', 'factorCtrl'])

        const canvas = Init.canvas

        const head = 25 * Init.scale
        const left = FOPTION.FWIDTH * Init.scale;
        // 设置顶部窗口
        setMclassCtrl(curChart, 'mclassCtrl', inData, {
            style: 'sidebar',
            top: 0,
            left: 0,
            width: canvas.width,
            height: head,
        })

        const high = canvas.height - head
        // 设置左部窗口
        setFactorCtrl(curChart, 'factorCtrl', inData, {
            style: 'sidebar',
            top: head,
            left: 0,
            width: left - Init.scale,
            height: high,
        })
        const minu = (canvas.width - left)
        // 设置分钟窗口
        setMinuteCtrl(curChart, 'minuteCtrl', inData, {
            style: 'sidebar',
            top: head,
            left: left,
            width: minu,
            height: head - Init.scale,
        })
        
        const half = minu / 2
        // 设置第一个窗口
        setMainChart(curChart, 'UpChart', inData, {
            style: 'average',
            top: head + head,
            left: left,
            width: half,
            height: high - head,
        })

        setMainChart(curChart, 'DnChart', inData, {
            style: 'average',
            top: head + head,
            left: left + half,
            width: half,
            height: high - head,
        })
    }

    readyMainChart(curChart, inData)

    curChart.onPaint()
}

function onLoadData(inData, isFirst) {
    const mclassname = getMclassName(inData)
    
    let minuteindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'minuteindex', 0), inData['minutes'].length)
    
    let factorindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'factorindex', 0), inData['factors'].datas.length)

    const factorname = CLAPI.getData(inData['factors'], 'name', factorindex)
    
    const cmds = {
        "assess": {
            "cmd": "get",
            "subject": factorname + ".db_assess",
            "service": inData.modulepath + '/' + mclassname + "/option/" + inData['minutes'][minuteindex],
            "info": {
                "offset": 0,
            }
        }
    }
    if (isFirst) {
        cmds['verify'] = {
            "cmd": "get",
            "subject": "CN000000" + ".db_verify",
            "service": inData.modulepath + '/' + mclassname + "/option/" + inData['minutes'][minuteindex],
            "info": {
                "offset": 0,
            }
        }
    }
    Init.sendCommand({ cmds },
        function reply(datas) {
            console.log(datas)
            if (Init.checkDatas(datas)) {
                if (isFirst) {
                    inData['verify'] = datas['verify']
                }
                inData['assess'] = datas['assess']
                drawFOption(inData, isFirst)
            }
        });
}

export function onClassLoad(inData) {

    const mclassname = getMclassName(inData)
    let minutes = [] 
    function onInit() {
        let minuteindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'minuteindex', 0), minutes.length)
        Init.sendCommand({
            cmds: {
                "factors": {
                    "cmd": "get",
                    "subject": "CN000000.factors",
                    "service": inData.modulepath + '/' + mclassname + "/option/" + minutes[minuteindex],
                    "info": {
                        "offset": 0,
                    }
                }
            }
        },
        function reply(datas) {
            // console.log(datas)
            if (Init.checkDatas(datas)) {
                inData['minutes'] = minutes
                inData['factors'] = datas['factors']
                onLoadData(inData, true)
            }
        });
    }
    Init.sendCommand({
            cmds: {
                "minutes": {
                    "cmd": "files",
                    "service": inData.modulepath + '/' + mclassname + "/option/*.mdb"
                }
            }
        },
        function reply(datas) {
            // console.log(mclassname, datas)
            if (Init.checkDatas(datas)) {
                // 这里更新分钟数据
                datas['minutes'].datas.sort((a,b) => b[1].localeCompare(a[1]))
                for (let index = 0; index < datas['minutes'].datas.length; index++) {
                    let fname = datas['minutes'].datas[index][1];
                    minutes.unshift(fname.split('.').slice(0, -1).join('.'));
                }
                FOPTION.onInit(inData['workers'], minutes)
                // console.log(minutes)
                onInit()
            }
            else {
                const mclassindex = Init.getUserInfo(inData.modulename, 'mclassindex', -1)
                Init.setUserInfo(inData.modulename, 'mclassindex', mclassindex + 1)
                console.log(mclassindex);
                
            }
        });
}

export function onLoad(argvs) {
    let inData = {}
    inData.modulename = argvs.modulename ?? 'option'
    inData.modulepath = argvs.modulepath ?? 'factors'

    inData['workers'] = ['really', 'before', 'zeasy', 'chip3', 'cscore']
    // inData['workers'] = ['zeasy', 'zeasy0', 'zeasy1', 'zeasy3']

    onClassLoad(inData)
}
// 注册方法到参数表